const RAW = `Chennayyagunta,Tirupati Urban
Konkachennaiahgunta,Tirupati Urban
Alukuralle,Chittoor
Anagallu,Chittoor
Ananthapuram,Chittoor
Anupalle,Chittoor
Arathala,Chittoor
Ayanavedu,Chittoor
Sakara Narasinga Rayal Peta,Chittoor
Bandapalle,Chittoor
Chinthalasunta,Chittoor
Diquvamasaalle,Chittoor
Gollapalle,Chittoor
Guvvakallu,Chittoor
Krishnapuram,Chittoor
Kurchivedu,Chittoor
Lakshmanbapuram,Chittoor
Mapakshi,Chittoor
Mapakshi,Chittoor
Muthukuru,Chittoor
Nariqapalle,Chittoor
Pachanaalle,Chittoor
Paluru,Chittoor
Peddistetiballe,Chittoor
Penumalla Khandriga,Chittoor
S.Venkatapuram,Chittoor
Settiappam Thangal,Chittoor
Siddampalle,Chittoor
Thalambedu,Chittoor
Thenebanda,Chittoor
Thumminda,Chittoor
Varadarajulapalle,Chittoor
Venkatapuram,Chittoor
Chimathippasamudram,Madanapalle
Kasiraopeta,Madanapalle
Kollabylu,Madanapalle
Kothavaripalle,Madanapalle
Madanapalle,Madanapalle
Malepadu,Madanapalle
Molakaladinne,Madanapalle
Penchupadu,Madanapalle
Ponnetipalem,Madanapalle
Pothapalu,Madanapalle
Theneegalavaripalle,Madanapalle
Valasapalle,Madanapalle
Vempalle,Madanapalle
Brahmana Pattu,Tirupati Rural
Chiguruwada North Khandriqa,Tirupati Rural
Chiguruwada South Khandriqa,Tirupati Rural
Daminedu,Tirupati Rural
Duraa Samudram,Tirupati Rural
Gollaqalle,Tirupati Rural
Kalur,Tirupati Rural
Kothur,Tirupati Rural
Kuntapakam,Tirupati Rural
Kupu Chandra Peta,Tirupati Rural
Mallam Gunta,Tirupati Rural
Mallavaram,Tirupati Rural
Mundlapudi,Tirupati Rural
Nallamani Kaiva,Tirupati Rural
Padi,Tirupati Rural
Paidi Palle,Tirupati Rural
Panakam,Tirupati Rural
Patha Kaiva,Tirupati Rural
Pudipatia,Tirupati Rural
Ramanuja Palle,Tirupati Rural
Thanaqalle,Tirupati Rural
Thummala Gunta,Tirupati Rural
Vedantha Puram,Tirupati Rural
Vemur,Tirupati Rural
Yogimalivaram,Tirupati Rural
Aradiourta,Punganur
Bandlapalle,Punganur
Bheemaganipalle,Punganur
Bodevaripalle,Punganur
Chadalla,Punganur
Chandramakula Palle,Punganur
Etsvakili,Punganur
Ethur,Punganur
Kummaranathan,Punganur
Magandlapalle,Punganur
Mangalam,Punganur
Melumdoddi,Punganur
Mittachinthavari Palle,Punganur
Nekkondi,Punganur
Palyampalle,Punganur
Punganur,Punganur
Raganjpalle,Punganur
Vanamalsdinne,Punganur
Adavikothuru,Nagari
Ćąaram,Nagari
Damarapakam,Nagari
Gundrajukuppam,Nagari
Kamikapuram,Nagari
Kavetipuram,Nagari
Manqadu,Nagari
Melapattu,Nagari
Mittapalem,Nagari
Mudipalle,Nagari
Nagarajukuppam,Nagari
Oranthanqai Gollaluppam,Nagari
Saraswathkulasapuram,Nagari
Taduku,Nagari
Therani,Nagari
Tinuvengamambapuram,Nagari
Veerakaverirajupuram,Nagari
Velavadi,Nagari
Venkatanarasimha - Rajuvaripet,Nagari
Bairupalle,Venkatagirikota
Bodiguttapalle,Venkatagirikota
Boya Chinnaganna Palle,Venkatagirikota
Chinna Kongatam,Venkatagirikota
Chintamakulapalle,Venkatagirikota
Gonumakulapalle,Venkatagirikota
Gudipalle,Venkatagirikota
Hanumaalle,Venkatagirikota
Jounipalle,Venkatagirikota
Konerugollapalle,Venkatagirikota
Kongatam,Venkatagirikota
Kothakota,Venkatagirikota
Krishnapuram,Venkatagirikota
Kumbarlapalle,Venkatagirikota
Matriguttapalle,Venkatagirikota
Mudaramdoddi,Venkatagirikota
Nadeetheeram Dasarlapalle,Venkatagirikota
Nemipalle,Venkatagirikota
Padipalakuppam,Venkatagirikota
Paipalle,Venkatagirikota
Panuganipalle,Venkatagirikota
Paperalle,Venkatagirikota
Patrapalle,Venkatagirikota
Pedda Bharanjpalle,Venkatagirikota
S.Bandapalle,Venkatagirikota
Shunikuppam,Venkatagirikota
Thota Kanuma,Venkatagirikota
Timmala Pichigundlapalle,Venkatagirikota
Venkatagirikota,Venkatagirikota
Vibhuthiyela Nagaram,Venkatagirikota
Voou,Venkatagirikota
YaLakallu,Venkatagirikota
Ayyameddi Palle,Palamaner
Baippagari Palle,Palamaner
Chethapenta,Palamaner
Gundlapalle,Palamaner
Jagamaria,Palamaner
Jallipeta,Palamaner
Karidimaduou,Palamaner
Kolamasana Palle,Palamaner
Kurmoi,Palamaner
Moram,Palamaner
Pengara Kunta,Palamaner
Ranganayanipalle,Palamaner
Samudrapalle,Palamaner
Sree Ranga Rajouram,Palamaner
Gollapalle,Puttur
Kasambuppam,Puttur
Kumarabommarajuouram,Puttur
Nandimangalam,Puttur
Neasnur,Puttur
Parameswara Mangalam,Puttur
Sirugurajupalam,Puttur
Taduku,Puttur
Thorur,Puttur
Tiirumalakuppam,Puttur
Utharapukhandriga,Puttur
Vepagunta,Puttur
Adusupalem,Renigunta
Ammavaripatteda,Renigunta
Amasamipalle,Renigunta
Athuru,Renigunta
Balupalle,Renigunta
Dharmapuram Khandriga,Renigunta
Elamandyam,Renigunta
Erragunta,Renigunta
Erranareddipalem,Renigunta
Gajulamandyam,Renigunta
Jeepalem,Renigunta
Karakambadi,Renigunta
Kothapalem,Renigunta
Kotramangalam,Renigunta
Krishnaiah Kalva,Renigunta
Krishnapuram,Renigunta
Kurukalva,Renigunta
Mamandur,Renigunta
Moiagamudi,Renigunta
Nallapalem,Renigunta
R. Maliavaram,Renigunta
Renigunta Agraharam,Renigunta
Sanjeevaravanipatteda,Renigunta
Srinivasaudasipuram,Renigunta
Suraprakasan,Renigunta
Thandlam,Renigunta
Thathaiah Kalva,Renigunta
Thukivakam,Renigunta
Vedullacheruyu,Renigunta
Venkatapuram,Renigunta
Beripalle,Bangarupalem
Bodabandla,Bangarupalem
Gollaolle,Bangarupalem
Gundla Kattamanchi,Bangarupalem
Jambuvaripalle,Bangarupalem
Kalurupalle,Bangarupalem
Kalvamoqilappa Kandriqa,Bangarupalem
Keeramanda,Bangarupalem
Kurmaiolle,Bangarupalem
Mahasamudram,Bangarupalem
Moqili,Bangarupalem
Mothagunta,Bangarupalem
Nalagampalle,Bangarupalem
Nallangadu,Bangarupalem
Noonegundlapalle,Bangarupalem
Palamakulapalle,Bangarupalem
Paleru,Bangarupalem
Raginranipenta,Bangarupalem
Sadakuppam,Bangarupalem
Setteri,Bangarupalem
Tekumanda,Bangarupalem
Thambuganipalle,Bangarupalem
Thoompavanapalle,Bangarupalem
Thumba,Bangarupalem
Thumba Kuppam,Bangarupalem
Venkatagiri,Bangarupalem
Vepanapalle,Bangarupalem
Agraharam,Pileru
Avuvaripalle,Pileru
Bodumaluvaripalle,Pileru
Doddipalle,Pileru
Sudarevupalle,Pileru
Jandia,Pileru
Kavalipalle,Pileru
Maddelacheruvu,Pileru
Mellacheruvu,Pileru
Mudupulavemula,Pileru
Regullu,Pileru
Talupula,Pileru
Vepulabylu,Pileru
Yerrasuntiapalle,Pileru
B.Kothakota,B.Kothakota
Badikayalaoalle,B.Kothakota
Bayyapasparipalle,B.Kothakota
Beerangi,B.Kothakota
Gatuu,B.Kothakota
Gollaoalle,B.Kothakota
Gummasantudram,B.Kothakota
Kotavooru,B.Kothakota
Thummanamoutta,B.Kothakota
Apoinapalle,Peddapanjani
Battamdoddi,Peddapanjani
Bommarajuopille,Peddapanjani
Chalamangalam,Peddapanjani
Chamaneru,Peddapanjani
Gamkonda,Peddapanjani
Karasanapalle,Peddapanjani
Koglieru,Peddapanjani
Kolathur,Peddapanjani
Mudarampalle,Peddapanjani
Muthukur,Peddapanjani
Nagireddinalle,Peddapanjani
Nidigunta,Peddapanjani
Peddakappalle,Peddapanjani
Peddapanjani,Peddapanjani
Peddavelagatur,Peddapanjani
Ravalabeta,Peddapanjani
Sankaravalapeta,Peddapanjani
Sivadi,Peddapanjani
Suddagundlapalle,Peddapanjani
Thurlapalle,Peddapanjani
Veerapalle,Peddapanjani
Agarala,Chandragiri
Arepalle,Chandragiri
Bheemavaram,Chandragiri
Chandragiri,Chandragiri
Chinna Rama Puram,Chandragiri
Chintagunta,Chandragiri
Dornakambala,Chandragiri
Ithepalle,Chandragiri
Kairoadpalle,Chandragiri
Kondreddy Khandriqa,Chandragiri
Kotala,Chandragiri
Mamandur,Chandragiri
Mittapalem,Chandragiri
Munollipattukothapalle,Chandragiri
Nagapatla,Chandragiri
Narasinqa Puram,Chandragiri
Panapakam,Chandragiri
Pullalahgari Palle,Chandragiri
Ramireddi Palle,Chandragiri
Reddivarioalle,Chandragiri
Sanambatla,Chandragiri
Sasha Puram,Chandragiri
Thondawada,Chandragiri
Achamma Agraharam,Pakala
Adenapalle,Pakala
Damakhenwu,Pakala
Gadanki,Pakala
Ganugaienta,Pakala
Gorgadu,Pakala
Maddinavanipalle,Pakala
Moqarala,Pakala
Nagamma Agraharam,Pakala
Oddepalle,Pakala
Padiputlabayalu,Pakala
Pakala,Pakala
Padda Ramapuram,Pakala
Thotathimmaiah Palle,Pakala
Vallivedu,Pakala
Alapalle,Baireddipalle
Baireddipalle,Baireddipalle
Belupalle,Baireddipalle
Chapoidipalle,Baireddipalle
Devadoddi,Baireddipalle
Dharmapuri,Baireddipalle
Donthirallapalle,Baireddipalle
Ganginavanipalle,Baireddipalle
Gollachemana Palle,Baireddipalle
Gounithimmepalle,Baireddipalle
Kadapanathan,Baireddipalle
Kaipallu,Baireddipalle
Kambhampalle,Baireddipalle
Kammanapalle,Baireddipalle
Lakkanapalle,Baireddipalle
Meakalanagireddi Palle,Baireddipalle
Mulathimmepalle,Baireddipalle
Nellipatia,Baireddipalle
Pathumatham,Baireddipalle
Peddschellaragunta,Baireddipalle
Raghunayakula Dinne,Baireddipalle
Settipalle,Baireddipalle
Theertham,Baireddipalle
Thimmaiahparipalle,Baireddipalle
Veerlabanda,Baireddipalle
Dandapalle,Gangavaram
Gandrajupalle,Gangavaram
Gangavaram,Gangavaram
Gundugallu,Gangavaram
Jeedimakulapalle,Gangavaram
Kalagatoor,Gangavaram
Kallupalle,Gangavaram
Keelapalle,Gangavaram
Keelapatia,Gangavaram
Kothapalle,Gangavaram
Mamadugu,Gangavaram
Maredupalle,Gangavaram
Melumoy,Gangavaram
Moqilpalle,Gangavaram
Pasupathur,Gangavaram
Pathikonda,Gangavaram
Aragonda,Thavanampalle
Cheriopalle,Thavanampalle
Diguva Magham,Thavanampalle
Diguva Thadakara,Thavanampalle
Eachanei,Thavanampalle
Eguva Thadakara,Thavanampalle
Gandupalle,Thavanampalle
Govindareddipalle,Thavanampalle
Gurukavaripalle,Thavanampalle
Karakampalle,Thavanampalle
Kattakindapalle,Thavanampalle
Madhavaram,Thavanampalle
Mallakunta,Thavanampalle
Mathyam,Thavanampalle
Muthukur,Thavanampalle
Nalisettipalle,Thavanampalle
Palmaghan,Thavanampalle
Pallechenwu,Thavanampalle
Patnam,Thavanampalle
Punya Samudram,Thavanampalle
Sarakallu,Thavanampalle
Thavanampalle,Thavanampalle
Thavanampalle Puttur,Thavanampalle
Uthara Brahmanapalle,Thavanampalle
Amaljabandskota,Pedda Thippasamu/dram
Ananthapuram,Pedda Thippasamu/dram
Bootiapalle,Pedda Thippasamu/dram
Buchipalle,Pedda Thippasamu/dram
Chinpapongupalle,Pedda Thippasamu/dram
Jagadamvaripalle,Pedda Thippasamu/dram
Kamsalavandla Palle,Pedda Thippasamu/dram
Kandiduru,Pedda Thippasamu/dram
Katnagallu,Pedda Thippasamu/dram
Maddalahgaripalle,Pedda Thippasamu/dram
Madunuru,Pedda Thippasamu/dram
Malleia,Pedda Thippasamu/dram
Pattamvandlapalle,Pedda Thippasamu/dram
Peddathippasamu/dram,Pedda Thippasamu/dram
Pullkallu,Pedda Thippasamu/dram
Rapgasamu/dram,Pedda Thippasamu/dram
Sampathikota,Pedda Thippasamu/dram
T.Sadum,Pedda Thippasamu/dram
Thummarakunta,Pedda Thippasamu/dram
Aryala Krishna Reddipalle,Irala
Chigarapalle,Irala
Erlampalle,Irala
Gundlapalle,Irala
Irala,Irala
Kaminayanipalle,Irala
Kanipakam,Irala
Kollapalle,Irala
Korbapalle,Irala
Morampalle,Irala
Mudigolam,Irala
Nampalle,Irala
Peddasamireddipalle,Irala
Polakala,Irala
Pulluru,Irala
Puthramaddi,Irala
Sanganapalle,Irala
Venkata Samudra Agraharam,Irala
Bhoomireddipalle,Yadamari
Bodaputtapalle,Yadamari
Budfihireddipalle,Yadamari
Dasarapalle,Yadamari
Golla palle,Yadamari
Jangalapalle,Yadamari
Kammapalle,Yadamari
Kanathalacheruvu,Yadamari
Kasiralla,Yadamari
Konapalle,Yadamari
Kotalam,Yadamari
Kukkalapalle,Yadamari
Madhavaram,Yadamari
Madireddipalle,Yadamari
Majara Kothapalle,Yadamari
Modipalle,Yadamari
Mudduramapuram,Yadamari
Nadimpalle,Yadamari
Otripalle,Yadamari
Ottvaripalle,Yadamari
Pattapalle,Yadamari
Periyambadi,Yadamari
Siddareddipalle,Yadamari
Yadamari,Yadamari
Arikela,Ramasamudram
Chembakur,Ramasamudram
Chokkandiaoalle,Ramasamudram
Elavaneliore,Ramasamudram
Kapoalle,Ramasamudram
Kudurucheemanaoalle,Ramasamudram
Kurilala,Ramasamudram
Malenathan,Ramasamudram
Miniki,Ramasamudram
Moogavadi,Ramasamudram
Nariganjoalle,Ramasamudram
Peddakuraoalle,Ramasamudram
R.Nadimoalle,Ramasamudram
Ramasamudram,Ramasamudram
Voolapadu,Ramasamudram
Cheekatipalle,Kalikiri
Gundloor,Kalikiri
Guttapalem,Kalikiri
Kalikiri,Kalikiri
Kalikirreddivari Palle,Kalikiri
Korlakunta,Kalikiri
Mahal,Kalikiri
Marrikuntaoalle,Kalikiri
Medilaurini,Kalikiri
Munellapalle,Kalikiri
Pallavolu,Kalikiri
Parapatia,Kalikiri
Pathepada,Kalikiri
T.Sandraoalle,Kalikiri
Alathur,Karvetinagar
Amur,Karvetinagar
Battuvaripalle,Karvetinagar
Damodara Maharajapuram,Karvetinagar
Eduvaripalle,Karvetinagar
Erzamrajupalle,Karvetinagar
Gazanki,Karvetinagar
Gopichettipalle,Karvetinagar
Karvetinagar,Karvetinagar
Kasavarajapura Aqrahaman,Karvetinagar
Katherapalle,Karvetinagar
Kesavakuppam,Karvetinagar
Kethumatmaharajapuram,Karvetinagar
Kollaguuta,Karvetinagar
Kotarvedu,Karvetinagar
Krishnasamuidram,Karvetinagar
Lakshmirajupet,Karvetinagar
Makamanbavilasam,Karvetinagar
Mukkaravaripalle,Karvetinagar
Nissankaduroam,Karvetinagar
Pomasgallu,Karvetinagar
Rajakumaravenkata Bahadurnet,Karvetinagar
Surendranagaram,Karvetinagar
Tirumalakondamambagaripeta,Karvetinagar
Viratapuram,Karvetinagar
Aogichenupalle,Vedurukuppam
Allamadugu,Vedurukuppam
Bommaiahpalle,Vedurukuppam
Brahmaangalle,Vedurukuppam
Chenchuoudi,Vedurukuppam
Devalampeta,Vedurukuppam
Dewaraguidipalle,Vedurukuppam
Garampalle,Vedurukuppam
Goduouchintha,Vedurukuppam
Inamkothuru,Vedurukuppam
�Jakkoidona,Vedurukuppam
Kaverimaharajulunparjajaraharam,Vedurukuppam
Komaragunta,Vedurukuppam
Kondakindapalle,Vedurukuppam
Kurivikuppam,Vedurukuppam
Makanabapuram,Vedurukuppam
Mambedu,Vedurukuppam
Marepalle,Vedurukuppam
Marripalleuttarapu-Khandriqa,Vedurukuppam
Mondivenganapalle,Vedurukuppam
Pachikapalem,Vedurukuppam
Pathagunta,Vedurukuppam
Perumailapalle,Vedurukuppam
Tarlabylu,Vedurukuppam
Thettuguntapalle,Vedurukuppam
Thippinaidupalle,Vedurukuppam
Tirumalakondamambapuram,Vedurukuppam
Vedurukuppam,Vedurukuppam
Venugopalapuram,Vedurukuppam
Veperi,Vedurukuppam
Akanambattu,Puthalapattu
Baltapalle,Puthalapattu
Chitipiralla,Puthalapattu
Errachenuvupalle,Puthalapattu
Goduguchimta,Puthalapattu
Kothakota,Puthalapattu
Muthirevula,Puthalapattu
Oddepalle,Puthalapattu
Palakuru,Puthalapattu
Paturu,Puthalapattu
Peta Agraharam,Puthalapattu
Polavaram,Puthalapattu
Potukanuma,Puthalapattu
Puthalapattu,Puthalapattu
Thalupulapalle,Puthalapattu
Thenepalle,Puthalapattu
Thippanapalle,Puthalapattu
Vavithota,Puthalapattu
Venuthanapalle,Puthalapattu
Vepanapalle,Puthalapattu
Burakayalakota,Mulakalachenwu
Chennaiahpariipalle,Mulakalachenwu
Devalchenwu,Mulakalachenwu
Devarapalle,Mulakalachenwu
Gudupalle,Mulakalachenwu
Kadirinathunikota,Mulakalachenwu
Kalavapalle,Mulakalachenwu
Maddinayanipalle,Mulakalachenwu
Marellapadda,Mulakalachenwu
Mulakalachenwu,Mulakalachenwu
Nayanichenwupalle,Mulakalachenwu
Peddapalem,Mulakalachenwu
Sompalle,Mulakalachenwu
T.Sowdasamudram,Mulakalachenwu
Vepurikota,Mulakalachenwu
Aramadaka,Valmikipuram
Avyawaripalle,Valmikipuram
Budidavedu,Valmikipuram
Chintaparthi,Valmikipuram
Chinthalavaripalle,Valmikipuram
Gandaboyanapalle,Valmikipuram
Jammallapalle,Valmikipuram
Jarrawaripalle,Valmikipuram
Kuraparthi,Valmikipuram
Manchuru,Valmikipuram
Mugalamarri,Valmikipuram
Naqarimadugu,Valmikipuram
T.Sakirevupalle,Valmikipuram
Thartiguntapalle,Valmikipuram
Valmikipuram,Valmikipuram
Velagapalle,Valmikipuram
Vittalam,Valmikipuram
Ambur,Varadalahpalle
Arudur,Varadalahpalle
Avyavaripalle,Varadalahpalle
C.I. Naidu Palle,Varadalahpalle
Chedulapakam,Varadalahpalle
Chilamathur,Varadalahpalle
Chinnapandur,Varadalahpalle
Gudalavaripalle,Varadalahpalle
Kadur,Varadalahpalle
Kalathur,Varadalahpalle
Kambakam,Varadalahpalle
Karepakam,Varadalahpalle
Kovurpadu,Varadalahpalle
Kurinjalam,Varadalahpalle
Kuvvakolli,Varadalahpalle
Maradawada,Varadalahpalle
Mopurapalle,Varadalahpalle
Nellatur,Varadalahpalle
Padirikuppam,Varadalahpalle
Pandur,Varadalahpalle
Racheria,Varadalahpalle
Santhavellore,Varadalahpalle
Sathambedu,Varadalahpalle
Siddamma Agraharam,Varadalahpalle
Thondambattu,Varadalahpalle
Thondur,Varadalahpalle
Varadalahpalle,Varadalahpalle
Vittaiah Palem,Varadalahpalle
Yanadivettu,Varadalahpalle
Avulapalle,Somala
Inkiperta,Somala
Kamireddivaripalle,Somala
Kandur,Somala
Mittapalle,Somala
Naniampeta @ Chandambylu,Somala
Nellimanda,Somala
Peddauppara Palle,Somala
S. Nadim Palle,Somala
Somala,Somala
Thamminavantpalle,Somala
Upparapalle,Somala
Valligatia,Somala
Adilakshmamba Puram,Gudipala
Bandapalle,Gudipala
Bandarlapalle,Gudipala
Basavapalle,Gudipala
Bomma Samudram,Gudipala
Cheelapalle,Gudipala
Cheruvu Mundara Khandriqa,Gudipala
Chittapara,Gudipala
Dakshina Brahmana Palle,Gudipala
Gollapalle,Gudipala
Gudipala,Gudipala
Kaiduqani Khandriqa,Gudipala
Kotbapalle,Gudipala
Krishna Jammapuram,Gudipala
Kuppiganipalle,Gudipala
Mandi Krishnapuram,Gudipala
Marakaiakuppam,Gudipala
Moqaralapalle,Gudipala
Muthukurpalle,Gudipala
Nanganangalam,Gudipala
Naragallu,Gudipala
Papasamudram,Gudipala
Pasumanda,Gudipala
Ragimanupatteda,Gudipala
Ramapuram,Gudipala
Ramapuram,Gudipala
Sriranganpalle,Gudipala
Thimmalahpalle,Gudipala
Vasanthapuram,Gudipala
Venkata Lakshmamba Puram,Gudipala
Amiepalle,Gurramkonda
Arigalavaripalle,Gurramkonda
Cheriopalle,Gurramkonda
Chittiboyanapalle,Gurramkonda
Gurramkonda,Gurramkonda
Khandriqa,Gurramkonda
Marrimakulapalle,Gurramkonda
Marripadu,Gurramkonda
Nadimikhandriqa,Gurramkonda
Pasalavandia Palle,Gurramkonda
Ramapuram,Gurramkonda
Sangasamuofram,Gurramkonda
Sarimadugu,Gurramkonda
Setivaripalle,Gurramkonda
Thariqonda,Gurramkonda
Thariqondarajuqalle,Gurramkonda
Yellutla,Gurramkonda
Boppasamudram,Kambhamvaripalle
Galivaripalle,Kambhamvaripalle
Garnimitta,Kambhamvaripalle
Gorantiaoalle,Kambhamvaripalle
Gyarampalle,Kambhamvaripalle
Hissapalle,Kambhamvaripalle
Jillellamanda,Kambhamvaripalle
Kambhamvaripalle,Kambhamvaripalle
Kasireddipalle,Kambhamvaripalle
Maddipattavandlapalle,Kambhamvaripalle
Mahalrajuqalle,Kambhamvaripalle
Marella,Kambhamvaripalle
Matamoalle,Kambhamvaripalle
Noothanakalva,Kambhamvaripalle
Sorakayalapet,Kambhamvaripalle
Theethavaquma Palle,Kambhamvaripalle
Thimmapuram,Kambhamvaripalle
Thuvvapalle,Kambhamvaripalle
Vaqalla,Kambhamvaripalle
Yerlampalle,Kambhamvaripalle
29 - A. Chinta - Makulapalle,Chowdepalle
A.Kothakota,Chowdepalle
Charala,Chowdepalle
Chowdepalle,Chowdepalle
Djouvapalle,Chowdepalle
Durgasamudram,Chowdepalle
Gaddamvaripalle,Chowdepalle
Katiperi,Chowdepalle
Kogathi,Chowdepalle
Kondamarri,Chowdepalle
Laddigam,Chowdepalle
Pandillapalle,Chowdepalle
Peddayallakuntia,Chowdepalle
Pudipatia,Chowdepalle
Settibeta,Chowdepalle
Ammagaripalle,Penumuru
Charvaganipalle,Penumuru
Chennasamudra Agraharam,Penumuru
Chinnamaredd Khandriga,Penumuru
Chinthapenta,Penumuru
Guntipalle,Penumuru
Kaligiri,Penumuru
Kakragunta,Penumuru
Kamachinnalahpalle,Penumuru
Kondama Agraharam,Penumuru
Mopireddipalle,Penumuru
Nanjarapalle,Penumuru
Penumuru,Penumuru
Pullkaliu,Penumuru
Samireddipalle,Penumuru
Sathambakam,Penumuru
Thathireddipalle,Penumuru
Angaliu,Kurabalakota
Brahmanavoddu Palle,Kurabalakota
Kurabalakota,Kurabalakota
Matihvaripalle,Kurabalakota
Muqivedu,Kurabalakota
Pitchalavandia Palle,Kurabalakota
Thettu,Kurabalakota
Diguvapalem,Thamballapalle
Eddulavaripalle,Thamballapalle
Gangireddipalle,Thamballapalle
Gopidinne,Thamballapalle
Gundlapalle,Thamballapalle
Kannemadugu,Thamballapalle
Kosuvaripalle,Thamballapalle
Kotakonda,Thamballapalle
Kotala,Thamballapalle
Kukkarajuqalle,Thamballapalle
Marrimakulapalle,Thamballapalle
Panchalamari,Thamballapalle
Renimakulapalle,Thamballapalle
Thamballapalle,Thamballapalle
Yerrasanjpalle,Thamballapalle
Zunlurupenta,Thamballapalle
Ayyavandlapalle,Pulicheria
Bandaruvaripalle,Pulicheria
Bodireddigaripalle,Pulicheria
Devalampet,Pulicheria
E.Ramireddigari Palle,Pulicheria
Gaddamvaripalle,Pulicheria
Kallur,Pulicheria
Kavetigaripalle,Pulicheria
Mangalampeta,Pulicheria
Ramireddigaripalle,Pulicheria
Rayavaripalle,Pulicheria
...`;

const BASE_LOCATIONS = RAW.split(/\r?\n/).filter(Boolean).map((line) => {
  const [villagePart, ...mandalParts] = line.split(',');
  const village = villagePart ? villagePart.trim() : '';
  const mandal = mandalParts.join(',').trim();
  return { village, mandal };
});

// Additional mandals requested to be available in the New Project form for Chitoor projects
const ADDITIONS: { village: string; mandal: string }[] = [
  { village: 'Sadum', mandal: 'Sadum' },
  { village: 'Pulicherla', mandal: 'Pulicherla' },
  { village: 'Rompicherla', mandal: 'Rompicherla' },
  { village: 'Vijayapuram', mandal: 'Vijayapuram' },
  { village: 'G.D. Nellore', mandal: 'G.D. Nellore' },
  { village: 'Palasamudram', mandal: 'Palasamudram' },
];

export const CHITOOR_LOCATIONS = [...BASE_LOCATIONS, ...ADDITIONS];

export default CHITOOR_LOCATIONS;
